import GameRankingItem from './GameRankingItem'
export default GameRankingItem;